export const rLanguage = {
  defaultToken: '',
  tokenPostfix: '.r',

  keywords: [
    'if', 'else', 'repeat', 'while', 'function', 'for', 'in', 'next', 'break',
    'TRUE', 'FALSE', 'NULL', 'Inf', 'NaN', 'NA', 'NA_integer_', 'NA_real_',
    'NA_complex_', 'NA_character_'
  ],

  builtins: [
    'c', 'mean', 'sum', 'sd', 'var', 'min', 'max', 'range', 'length',
    'library', 'require', 'plot', 'hist', 'boxplot', 'barplot', 'print',
    'read.csv', 'write.csv', 'data.frame', 'matrix', 'list', 't.test'
  ],

  operators: [
    '<-', '<<-', '->', '->>', '=', '+', '-', '*', '/', '^', '%%', '%/%',
    '==', '!=', '<', '<=', '>', '>=', '&', '&&', '|', '||', '!'
  ],

  // The main tokenizer for our R language
  tokenizer: {
    root: [
      [/[a-zA-Z_][\w.]*/, {
        cases: {
          '@keywords': 'keyword',
          '@builtins': 'type.identifier',
          '@default': 'identifier'
        }
      }],
      { include: '@whitespace' },
      [/@operators/, 'operator'],
      [/\d+(\.\d+)?/, 'number'],
      [/".*?"/, 'string'],
      [/'[^']*'/, 'string'],
      [/[()[\]{}]/, '@brackets']
    ],

    whitespace: [
      [/[ \t\r\n]+/, ''],
      [/#.*$/, 'comment']
    ]
  }
};
